import { render } from "./AppSelect.vue?vue&type=template&id=90af6b0c&ts=true"
import script from "./AppSelect.vue?vue&type=script&lang=ts"
export * from "./AppSelect.vue?vue&type=script&lang=ts"

import "./AppSelect.vue?vue&type=style&index=0&id=90af6b0c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__